<p-toolbar [style]="{'position':'sticky !important', 'top':'0', 'z-index':'1000', 'padding':'12px', 
  'border':'none', 'border-radius':'0px'}" class="app-toolbar bg-white text-blue-950 flex-nowrap">

  <ng-template pTemplate="start">
    <button class="flex items-center cursor-pointer gap-2 rounded-md hover:bg-primary-50 px-3"
      routerLink="/portal-home">
      <img class="h-10 w-12" src="../assets/images/jax-logo.png" alt="JAX logo" />
      <span class="text-xl font-black">JAX BioConnect</span>
    </button>
  </ng-template>

  <ng-template pTemplate="center">
    <p-menubar [model]="menuItems" [style]="{'border':'none'}" class="app-menubar bg-white text-blue-950"
      breakpoint="1150px">
      <ng-template #item let-item let-root="root">
        <a pRipple class="flex items-center px-3 py-2 cursor-pointer gap-4">
          <span class="text-md font-bold text-blue-950">{{ item.label }}</span>
          @if (item.shortcut) {
          <span class="ms-auto border border-surface rounded-sm bg-emphasis text-muted-color text-xs p-1">{{
            item.shortcut }}</span>
          }
          @if (item.items) {
          <i [class]="'ms-auto pi ' + (root ? 'pi-angle-down' : 'pi-angle-right')"></i>
          }
        </a>
      </ng-template>
    </p-menubar>
  </ng-template>

  <ng-template pTemplate="end">
    @let user = auth.user$ | async;
    <div class="flex items-center gap-4 text-sm">
      @if (user) {
      <p-menu #userMenu [model]="userMenuItems" [popup]="true">
        <ng-template pTemplate="item" let-item>
          <a class="flex items-center py-2 px-3 gap-4 cursor-pointer">
            <span class="text-md font-bold text-blue-950">{{ item.label }}</span>
          </a>
        </ng-template>
      </p-menu>
      <!-- <button pButton pRipple type="button"
        class="user-avatar text-blue-950 text-sm font-bold border-0 rounded-full h-10 min-w-10 px-3 flex items-center gap-2"
        (click)="userMenu.toggle($event)">
        <span>{{ getUserInitials(user) }}</span>
        <i class="pi pi-angle-down text-xs"></i>
      </button> -->

      <button class="flex items-center cursor-pointer gap-2 py-2  rounded-md hover:bg-primary-50 px-3"
        >
        <a href="https://docs.bioconnect.jax.org/home/feedback" target="_blank" class="text-base">Provide Feedback</a>
      </button>

      <img [src]="user.picture" alt="user" class="h-8 w-8 rounded-full">

      <button pButton type="button" (click)="auth.logout({ logoutParams: { returnTo: document.location.origin } })"
        class="bg-white text-blue-950 text-lg font-bold border-0">
        Log out
      </button>
      }
      @if ((auth.isAuthenticated$ | async) === false) {
      <span class="text-2xl">
        <button pButton type="button" class="bg-white text-blue-950 text-lg font-bold border-0" label="Log in"
          (click)="login()"></button>
      </span>
      }
    </div>
  </ng-template>

</p-toolbar>

@let isAuthenticated = (auth.isAuthenticated$ | async) === true;
<div class="portal-container" [class.responsive-screen-width]="isAuthenticated"
  [class.manual-width-override]="overrideScreenSize === true" [class.home-scrollbar-hidden]="isHomePage">
  @if (isAuthenticated && !isHomePage) {
  <bioconnect-ui-breadcrumb-nav></bioconnect-ui-breadcrumb-nav>
  }
  <div class="content">
    <router-outlet></router-outlet>
  </div>
</div>
<p-toast [preventOpenDuplicates]="true"></p-toast>